import { FC } from "react";
import { OrderModel, OrderProductModel } from "../../models";
import { formatCurrency, formatDate } from "../../utilities";
import { OrderStatusEnum } from "../../enums";

type Props = {
  order: OrderModel;
  onTrack: () => void;
  onShow: () => void;
};

export const OrderBox: FC<Props> = ({ order, onTrack, onShow }) => {
  return (
    <>
      <div className="dashbord_sec3">
        <div className="dashbord_sec3_left">
          <p>
            <span className="order_number">Order #{order.order_id}</span>{" "}
             <span className="order-status-badge completed"> {order?.status_name} </span>
          </p>
          <p className="order_placed">
             {formatDate(order.create_ts)}
          </p>
          <p className="order_placed">
            {order.products.map((product: OrderProductModel, key: any) => (
              <span key={key}>
                {product.product_name} <i>x {product.product_qty}</i> &nbsp;
              </span>
            ))}
          </p>
          <p className="fw-bolder">{formatCurrency(order.order_total)}</p>
        </div>
        <div className="dashbord_sec3_right">
          <div className="view_track_btn">
            {Number(order.status_id) != OrderStatusEnum.COMPLETED && (
              <button className="track_btn text-nowrap" onClick={onTrack}>
                Track
              </button>
            )}
            <button className="view_order_btn text-nowrap" onClick={onShow}>
              View Order
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
